<section
  class="flex flex-col justify-between gap-4 bg-gradient-to-r from-[#0b254e] to-[#154fa0] py-6 text-white md:flex-row"
>
  <app-ticket-count-chart
    class="mt-4 flex w-full flex-col self-center px-4 md:mt-0 md:flex-1 md:px-0 md:pr-0"
    [tickets]="tickets"
    [isLoading]="isLoading"
    [ticketAggregate]="aggregate"
    (timeRangeChanged)="onTimeRangeChanged($event)"
  ></app-ticket-count-chart>
  <app-ticket-type-chart
    class="hidden w-full justify-center self-center md:flex md:flex-1"
    [ticketAggregate]="aggregate"
    [isLoading]="isLoading"
    [tickets]="tickets"
  ></app-ticket-type-chart>
</section>
